<template>
  <div v-if="showMigration" class="status-container">
    <div class="backdrop"></div>
    <div class="status-box">
      <h3>Applying Data Migration</h3>
      <hr class="divider" />
      <div class="loading-indicator">
        <div class="spinner"></div>
        {{ status }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as getters from '@/js/store/modules/getters'
import { SiteMigration } from '@/js/store/services/migrations/SiteMigration'
import { PopupMigration } from '@/js/store/services/migrations/PopupMigration'

export default {
  data() {
    return {
      status: 'Initializing...',
    }
  },
  computed: {
    ...mapGetters({
      siteData: getters.SITE_GET_DATA,
      popupData: getters.SDA_POPUP_SITE_DATA,
      config: getters.AUTH_GET_USER_CONFIG,
      currentProductVersion: getters.CURRENT_PRODUCT_VERSION_NUMBER,
      isGridBuilder: getters.IS_GRID_BUILDER,
      vdomReady: getters.DELTA_VDOM_READY,
    }),
    ...mapGetters('migration', {
      showMigration: 'hasQueueItems',
      messageLog: 'messageLog',
    }),
    hasSiteData() {
      return this.siteData && this.siteData.id
    },
  },
  watch: {
    vdomReady(newVal) {
      if (newVal) {
        this.checkForMigration()
      }
    },
    messageLog: {
      handler(log) {
        this.status = log
      },
      immediate: true,
    },
  },
  mounted() {
    console.debug('Migration Initialised')
  },
  destroyed() {
    // Cleanup is now handled by the migration services themselves
  },
  methods: {
    ...mapActions('loader', {
      startLoader: 'start',
      stopLoader: 'stop',
    }),
    ...mapActions('migration', {
      pushMigration: 'pushMigration',
    }),
    async checkForMigration() {
      if (!this.hasSiteData) {
        return
      }

      await this.initMigration()
      // Start running migrations if there are any in the queue
      // await this.startMigration({ route: this.$route })
    },
    async initMigration() {
      if (!this.config.MIGRATION_ENABLED) {
        return
      }
      const { PRODUCT_VERSION_NUMBER: productVersion } = this.config
      const userProductVersion = parseFloat(productVersion)

      if (this.popupData) {
        await this.initPopupMigration(userProductVersion)
      } else {
        await this.initSiteMigration(userProductVersion)
      }
    },
    async initSiteMigration(userProductVersion) {
      if (
        this.isGridBuilder &&
        this.currentProductVersion < userProductVersion
      ) {
        const siteMigration = new SiteMigration({
          siteData: this.siteData,
          currentProductVersion: this.currentProductVersion,
          userProductVersion: userProductVersion,
          isGridBuilder: this.isGridBuilder,
        })
        this.pushMigration({
          migrator: siteMigration,
          route: this.$route
        })
      }
    },
    async initPopupMigration(userProductVersion) {
      if (
        this.isGridBuilder &&
        this.currentProductVersion < userProductVersion
      ) {
        const popupMigration = new PopupMigration({
          popupData: this.popupData,
          currentProductVersion: this.currentProductVersion,
          userProductVersion: userProductVersion,
          isGridBuilder: this.isGridBuilder,
        })

        this.pushMigration({
          migrator: popupMigration,
          route: this.$route
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);

  width: 100%;
  height: 100%;
  z-index: 1000;
}
.status-container {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.status-box {
  width: 400px;
  padding: 20px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  z-index: 1000;
  position: relative;
}

.divider {
  border: none;
  border-top: 1px solid #ccc;
  margin: 10px 0;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
